import { render } from "./actionsHeader.vue?vue&type=template&id=2bd2f779"
import script from "./actionsHeader.vue?vue&type=script&lang=js"
export * from "./actionsHeader.vue?vue&type=script&lang=js"

import "./actionsHeader.vue?vue&type=style&index=0&id=2bd2f779&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__